var AbstractPlayerView   = require("./AbstractPlayerView"),
    Layout               = require("./ReaderViewLayout"),
    ViewContainerSupport = require("app/core/ViewContainerSupport"),
    get                  = require("object-path").get,
    kind                 = require("enyo/kind"),
    onHyperlinkTap       = require("app/utils/onHyperlinkTap");

require("./ReaderView.less");

module.exports = kind(/** @lends  app.MediaPlayer.ReaderView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.ReaderView",

    /**
     * @private
     */
    kind: AbstractPlayerView,

    /**
     * @private
     */
    mixins: [ViewContainerSupport],

    /**
     * @private
     */
    classes: "app-media-player-reader-view",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     */
    isReusable: true,

    /**
     * @protected
     */
    update: function() {
        var state                   = this.state || {},
            $watchingSessionService = this.app.$.watchingSessionService,
            $player                 = this.getPlayerTech();

        if ($player) {
            if (get(state, "media", false)
                && get(state, "asset", false)
                && get($watchingSessionService, "session", false)) {
                $player.set("state", state);
            }
            else {
                $player && $player.set("state", null);
            }
        }
    },

    /**
     * Verify displayMode support
     *
     * @param    {string}   displayMode  The display mode
     * @returns  {boolean}  Whether the display mode is supported
     * @public
     */
    supportsDisplayMode: function(displayMode) {
        return displayMode === "maximized";
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
